import { takeLatest } from 'redux-saga/effects';
import { I18nActions } from '../actions/i18n.actions';

function* fetchI18nSaga(action) {
    /*const mapping = action.payload;
    if (isMappingLoaded(mapping)) {
        const {domain, countryLanguage} = mapping;
        const url = geti18nResourceUrl(domain, countryLanguage);

        const response = yield call(AEM.getResource, url);

        if (validResponse(response)) {
            yield put(setI18n(response.data));
        }
    }*/
}

export function* i18nSaga() {
    yield takeLatest(I18nActions.FETCH_I18N, fetchI18nSaga);
}
